import { render } from "./cashless-repairs.vue?vue&type=template&id=b5812e4a&scoped=true"
const script = {}

import "./cashless-repairs.vue?vue&type=style&index=0&id=b5812e4a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5812e4a"]])

export default __exports__